var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 214.98 214.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00c700;}.cls-2,.cls-3{opacity:0.2;}.cls-3,.cls-4{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5445.84,5401.44A107.49,107.49,0,1,0,5338.32,5509,107.52,107.52,0,0,0,5445.84,5401.44Z",
    transform: "translate(-5230.86 -5293.98)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5338.32,5493a107.48,107.48,0,0,1-107.16-99.52c-.19,2.64-.3,5.31-.3,8a107.49,107.49,0,1,0,215,0q0-4-.29-8A107.55,107.55,0,0,1,5338.32,5493Z",
    transform: "translate(-5230.86 -5293.98)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5338.32,5310a107.54,107.54,0,0,1,107.23,99.46q.28-4,.29-8a107.49,107.49,0,0,0-215,0c0,2.69.11,5.36.3,8A107.47,107.47,0,0,1,5338.32,5310Z",
    transform: "translate(-5230.86 -5293.98)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M5408.46,5368.74a8.82,8.82,0,0,0-2.52-6.18l-12.3-12.3a8.92,8.92,0,0,0-6.18-2.52,8.68,8.68,0,0,0-6.12,2.52L5322,5409.72l-26.58-26.7a8.92,8.92,0,0,0-6.18-2.52,8.68,8.68,0,0,0-6.12,2.52l-12.3,12.3a8.62,8.62,0,0,0,0,12.3l32.7,32.76,12.3,12.3a8.76,8.76,0,0,0,12.3,0l12.3-12.3,65.52-65.52a8.78,8.78,0,0,0,2.52-6.12Z",
    transform: "translate(-5230.86 -5293.98)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.7a4363eac29b74856c3dc151521a8a17.svg";
export { ForwardRef as ReactComponent };